import React, { useEffect } from "react";
import { Button, Row, UncontrolledTooltip } from "reactstrap";
import { useUserPermissions } from "../../utils/hooks/useUserPermissions";

export default function ActionButtonRounded(props) {
  const { canCreate, canUpdate, canDelete } = useUserPermissions();

  const {
    title,
    onClick,
    type = "web",
    color = "success",
    className = "btn-rounded waves-effect waves-light events-button-add",
    action = "C",
    width = "auto",
    setShow,
    verifyShow,
    margin = 0,
    tooltip = null,
    id = null,
    classTips = "show-tips",
  } = props;
  // esta no padrão de botao de criação

  /**
   - action
   C = create
   U = update
   D = delete

   - setShow / verifyShow
   apenas para botão de limpar listagem ao lado da paginação.
   validar para exibir botão para alinhar ele ao lado da paginação, ou, 
   caso não exiba, a paginação ficar no lado certo
   */

  const checkCanActions = () => {
    if (canCreate() && action === "C") return true;
    if (canUpdate() && action === "U") return true;
    if (canDelete() && action === "D") return true;
    return false;
  };

  function getShow() {
    if (verifyShow) {
      const show = checkCanActions();
      setShow(show);
    }
  }

  useEffect(() => {
    getShow();
  }, []);

  if (type === "mobile") {
    return (
      <>
        {checkCanActions() && (
          <Row className="mobile-btns-top">
            <div onClick={onClick}>{title}</div>
          </Row>
        )}
      </>
    );
  } else
    return (
      <>
        {checkCanActions() && (
          <>
            <Button
              color={color}
              className={className}
              onClick={onClick}
              style={{
                width: width,
                margin: margin,
                display: "flex",
                alignItems: "center",
                justifyContent: 'center'
              }}
            >
              {title}
              {tooltip && id && (
                <>
                  <div
                    className={classTips}
                    style={{ backgroundColor: "white", height: "auto" }}
                    id={id}
                  >
                    <span style={{ marginLeft: 0 }}>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="bottom"
                    target={id}
                  >
                    {tooltip}
                  </UncontrolledTooltip>
                </>
              )}
            </Button>
          </>
        )}
      </>
    );
}
